import React from 'react';

const HeroSection = () => {
  return (
    <section id="hero">
      <div className="container">
        <p className="hero-eyebrow">Full-Stack Developer</p>
        <h1>
          Building things<br />
          for the <em>web.</em>
        </h1>
        <p className="hero-sub">
          I build web and desktop applications with dependable delivery,
          maintainable code, and practical outcomes for teams and clients.
        </p>
        <div className="hero-actions">
          <a href="#resume" className="btn btn-outline">View resume</a>
          <a href="#contact" className="btn btn-ghost">Get in touch →</a>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;

